export default __webpack_public_path__ + "static/media/bannerImage1.66d7ce82.png";